module.exports = __webpack_public_path__ + "static/media/NotfmanageIcon.c6e990ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/NotfmanageIcon.svg
// module id = 1368
// module chunks = 0